<!--<button *ngIf="this.authService.instance.getAllAccounts().length == 0" (click)="login()">Login</button>
<button *ngIf="this.authService.instance.getAllAccounts().length > 0" (click)="logout()" >Logout</button>-->
<div class="loading-wrapper" *ngIf="loadingVisible">
    <p-progressBar class="app-loading-progress-bar" [style]="{height: '6px'}" [value]="loadingValue" [mode]="loadingMode"></p-progressBar>
</div>
<router-outlet></router-outlet>
<p-toast></p-toast>